import { useEffect } from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

function FacturePage() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  // =====================
  // FETCH PDF
  // =====================

  useEffect(() => {

    const fetchPDF =
      async () => {

        try {

          const token =
            localStorage.getItem(
              "accessToken"
            );

          const res =
            await fetch(
              `/api/factures/${id}/pdf`,
              {
                headers: {
                  Authorization:
                    "Bearer " +
                    token
                }
              }
            );

          const blob =
            await res.blob();

          const url =
            window.URL.createObjectURL(
              blob
            );

          window.open(
            url,
            "_blank"
          );

        } catch (err) {

          console.error(err);

        }
      };

    if (id) {

      fetchPDF();

    }

  }, [id]);

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 min-h-[100dvh] bg-gray-100 flex flex-col items-center justify-center">

      <div className="bg-white rounded-2xl shadow p-6 md:p-8 w-full max-w-md text-center">

        <h2 className="text-2xl md:text-3xl font-semibold mb-4">
          Facture
        </h2>

        <p className="text-gray-500 text-sm md:text-base">
          Ouverture de la facture en cours...
        </p>

        <button
          onClick={() =>
            navigate(-1)
          }
          className="mt-6 w-full md:w-auto px-5 py-3 bg-gray-700 hover:bg-black transition text-white rounded-xl"
        >
          ← Retour
        </button>

      </div>

    </div>
  );
}

export default FacturePage;